const INTERNAL_ID_PATTERN = /^(player:|temp:)?[a-f\d]{24}$/i;

export const isGaliInternalToken = (value) => typeof value === 'string' && INTERNAL_ID_PATTERN.test(value.trim());

export const normalizeGaliParticipantKey = (value, refType = '') => {
  if (typeof value === 'string' || typeof value === 'number') {
    const text = String(value).trim();
    if (/^(player|temp):[^:]+$/.test(text)) return text;
    if ((refType === 'player' || refType === 'temp') && text && text !== '[object Object]') return `${refType}:${text}`;
    return '';
  }
  if (!value || typeof value !== 'object') return '';
  if (value.participantKey) return normalizeGaliParticipantKey(value.participantKey);
  if (value.tempPlayerId || value.refType === 'temp') return normalizeGaliParticipantKey(value.tempPlayerId || value.id || value._id, 'temp');
  if (value.playerId || value.userId || value.refType === 'player') return normalizeGaliParticipantKey(value.playerId || value.userId || value.id || value._id, 'player');
  return '';
};

const displayFrom = (row = {}) => row.displayNameSnapshot || row.displayName || row.name || row.fullName || '';

export const resolveGaliParticipantDisplay = (participantKey, playerDirectory = [], teamRosters = {}) => {
  const key = normalizeGaliParticipantKey(participantKey);
  const players = [
    ...(Array.isArray(playerDirectory) ? playerDirectory : Object.values(playerDirectory || {})),
    ...(Array.isArray(teamRosters.battingRoster) ? teamRosters.battingRoster : []),
    ...(Array.isArray(teamRosters.bowlingRoster) ? teamRosters.bowlingRoster : []),
  ];
  const found = players.find((player) => normalizeGaliParticipantKey(player) === key || normalizeGaliParticipantKey(player?.participantKey) === key);
  const isTemporary = Boolean(found?.isTemporary || found?.temporary || found?.refType === 'temp' || key.startsWith('temp:'));
  const fallback = isTemporary ? `Temporary player${found?.tempNumber || found?.number ? ` #${found.tempNumber || found.number}` : ''}` : 'Unknown player';
  return {
    participantKey: key,
    displayName: displayFrom(found) || fallback,
    isTemporary,
    playerId: found?.playerId || (key.startsWith('player:') ? key.slice(7) : null),
    tempPlayerId: found?.tempPlayerId || (key.startsWith('temp:') ? key.slice(5) : null),
  };
};
